import React, { useState, useEffect } from "react";
import { Col, Container, Row } from "react-bootstrap";
import ResumeClinicRsvpFormModal from "./ResumeClinicRsvpFormModal";
import ResumeClinicDetails from "./ResumeClinicDetails";


export default function ResumeClinicEventDetailsAndRSVP() {
  const [title, setTitle] = useState("Eraconneckt Open Forum | Eraconneckt");

  useEffect(() => {
    document.title = title;
    setTitle(title);
  }, [title]);


  return (
    <>
      <section className="event-details-and-rsvp" id="event-details-and-rsvp">
        <Container
          style={{
            marginTop: "7.5rem",
          }}
        >
          <Row>
            <Col
              xs={{ span: 12, order: 1 }}
              md={{ span: 12, order: 1 }}
              lg={{ span: 7, order: 1 }}
            >
              <ResumeClinicDetails />
            </Col>
            <Col
              xs={{ span: 12, order: 2 }}
              md={{ span: 12, order: 2 }}
              lg={{ span: 5, order: 2 }}
            >
              <div
                style={{
                  marginTop: "3.75rem",
                }}
              >
                <ResumeClinicRsvpFormModal />
              </div>
            </Col>
          </Row>
        </Container>
      </section>
    </>
  );
}
